import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetDashboardAssessmentsQuery } from '../../../../utils/api_service/dashboardApi';
import { useDebouncedValue } from '../../hooks';
import { ADMIN_ROWS_PER_PAGE, ADMIN_SEARCH_DEBOUNCE_MS } from '../constants';
import { mapAssessmentsToRows } from '../functions';
import type { IAssessmentRow } from '../interfaces';
import type { AssessmentData } from '../../../../utils/types/DashboardTypes';

export const useAssessmentTab = (externalSearchTerm?: string) => {
  const history = useHistory();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const debouncedSearch = useDebouncedValue(externalSearchTerm ?? '', ADMIN_SEARCH_DEBOUNCE_MS);

  const { data, isLoading, isFetching } = useGetDashboardAssessmentsQuery({
    search: debouncedSearch,
    page: pageNumber,
    limit: ADMIN_ROWS_PER_PAGE,
  });

  const assessments: AssessmentData[] = data?.assessments ?? [];
  const totalRecords: number = (data as { totalAssessments?: number })?.totalAssessments ?? 0;
  const rows: IAssessmentRow[] = mapAssessmentsToRows(assessments);

  const totalPages = Math.max(1, Math.ceil(totalRecords / ADMIN_ROWS_PER_PAGE));

  const handleRowClick = (row: IAssessmentRow) => {
    history.push(`/view-assessment/${row.id}`);
  };

  const onPageChange = (page: number) => {
    setPageNumber(page);
  };

  return {
    handleRowClick,
    data: rows,
    loading: isLoading || isFetching,
    pageNumber,
    setPageNumber,
    totalPages,
    searchTerm: externalSearchTerm,
    onPageChange,
    totalRecords,
  };
};
